import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// quill 富文本编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import '@/assets/styles/iconfont/iconfont.css'

//froala-editor富文本编辑器
// import jquery from 'jquery';
// import 'froala-editor/css/froala_editor.pkgd.min.css';
// import 'froala-editor/js/languages/zh_cn';
// import  'froala-editor/css/froala_style.min.css';

// import VueFroala from 'vue-froala-wysiwyg';
// window.$ = jquery;
// Vue.use(VueFroala)
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// import '@/jslibs/plupload/js/plupload.full.min.js';
// import '@/jslibs/plupload/js/i18n/zh_CN.js';

// window.mOxie = window.moxie = require('./jslibs/plupload/js/moxie')
// window.mOxie = window.moxie = require('./jslibs/plupload/moxie')
// require('./jslibs/plupload/plupload.dev')
// require('./jslibs/qiniu')

Vue.use(VueQuillEditor, /* { default global options } */)

require('./jslibs/verify-code.min');

Vue.config.productionTip = false
Vue.use(ElementUI);


window.vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
